import { defineComponent as t, openBlock as s, createElementBlock as r, mergeProps as o, renderSlot as n } from "vue";
import "./ghl-ui.es223.js";
const m = t({
  name: "UITextXsMedium",
  inheritAttrs: !1
}), a = t({
  ...m,
  setup(l) {
    return (e, i) => (s(), r("div", o(e.$attrs, { class: "hl-text-xs-medium" }), [
      n(e.$slots, "default")
    ], 16));
  }
}), p = a;
export {
  p as default
};
